export default {"src":"/_next/static/media/vivint-logo.9da0d8ca.svg","height":40,"width":179};